import { ReferenceType } from './reference';

export type ContactRole = 'BUYER' | 'SELLER';

export type SuggestedContactReferenceType = ReferenceType.PROPERTY;

export enum IdentityDocumentType {
  IDENTITY_CARD = 'IDENTITY_CARD',
  PASSPORT = 'PASSPORT',
  DRIVER_LICENSE = 'DRIVER_LICENSE',
}
